<!-- ======= Skills Section ======= -->
<section id="skills" class="skills section-bg">
  <div class="container" data-aos="fade-up">
    <div class="section-title">
      <h2>Skills</h2>
    </div>

    <div class="row skills-content">
      <div class="col-lg-4">
        <div class="progress">
          <span class="skill">HTML</span>
        </div>

        <div class="progress">
          <span class="skill">CSS</span>
        </div>

        <div class="progress">
          <span class="skill">JavaScript</span>
        </div>

        <div class="progress">
          <span class="skill">Angular</span>
        </div>

        <div class="progress">
          <span class="skill">Typescript</span>
        </div>
      </div>

      <div class="col-lg-4">
        <div class="progress">
          <span class="skill">NgRx</span>
        </div>

        <div class="progress">
          <span class="skill">RxJs</span>
        </div>

        <div class="progress">
          <span class="skill">Ionic</span>
        </div>

        <div class="progress">
          <span class="skill">Spartacus</span>
        </div>

        <div class="progress">
          <span class="skill">Bootstrap</span>
        </div>

        <div class="progress">
          <span class="skill">Node</span>
        </div>
      </div>

      <div class="col-lg-4">
        <div class="progress">
          <span class="skill">Sass</span>
        </div>

        <div class="progress">
          <span class="skill">React</span>
        </div>

        <div class="progress">
          <span class="skill">Redux</span>
        </div>

        <div class="progress">
          <span class="skill">Git</span>
        </div>

        <div class="progress">
          <span class="skill">Materialize</span>
        </div>
      </div>
    </div>
  </div>
</section>
<!-- End Skills Section -->
